module.exports = __webpack_public_path__ + "static/media/logo.302a4a21.png";